export default "__VITE_ASSET__DgxW_Wb___"